/**
 * The app icon sprite's name -> symbol-id map, handed to Quasar's `iconMapFn`.
 *
 * Data, not behaviour, and 200 lines of it — which is why it lives in its own file rather than at the top
 * of the component that used to hold it. `useAppShell.iconMapFn` turns it into the resolver; nothing else
 * reads it.
 */
export const APP_ICONS: Record<string, string> = {
  'app:active': '#bs-active',
  'app:active-arcs': '#bs-active-arcs',
  'app:all-authors': '#bs-all-authors',
  'app:amazon': '#bs-amazon',
  'app:amazon-original': '#bs-amazon-original',
  'app:american-express': '#bs-american-express',
  'app:apple': '#bs-apple',
  'app:arcs': '#bs-arcs',
  'app:arrow-down': '#bs-arrow-down',
  'app:arrow-left': '#bs-arrow-left',
  'app:arrow-left-slim': '#bs-arrow-left-slim',
  'app:arrow-right': '#bs-arrow-right',
  'app:arrow-right-slim': '#bs-arrow-right-slim',
  'app:arrow-right-alt': '#bs-arrow-right-alt',
  'app:arrow-up': '#bs-arrow-up',
  'app:audible': '#bs-audible',
  'app:audiobook': '#bs-audiobook',
  'app:audiobook-alt': '#bs-audiobook-alt',
  'app:author-role': '#bs-author-role',
  'app:authors-direct': '#bs-authors-direct',
  'app:award': '#bs-award',
  'app:back': '#bs-back',
  'app:badge-filled': '#bs-badge-filled',
  'app:badge-new-reviewer': '#bs-badge-new-reviewer',
  'app:badge-outline': '#bs-badge-outline',
  'app:badge-valued-reviewer': '#bs-badge-valued-reviewer',
  'app:badge-top-reviewer': '#bs-badge-top-reviewer',
  'app:ban': '#bs-ban',
  'app:barnes': '#bs-barnes',
  'app:billing': '#bs-billing',
  'app:bin': '#bs-bin',
  'app:block': '#bs-block',
  'app:book': '#bs-book',
  'app:book-file-updated': '#bs-book-file-updated',
  'app:bookbub': '#bs-bookbub',
  'app:bookmark': '#bs-bookmark',
  'app:books': '#bs-books',
  'app:booksprout': '#bs-booksprout',
  'app:booksprout-dense': '#bs-booksprout-dense',
  'app:booksprout-leaf': '#bs-booksprout-leaf',
  'app:browse': '#bs-browse',
  'app:categories': '#bs-categories',
  'app:calendar': '#bs-calendar',
  'app:calendar-next': '#bs-calendar-next',
  'app:calendar-prev': '#bs-calendar-prev',
  'app:cancel-filled': '#bs-cancel-filled',
  'app:cancelled-arcs': '#bs-cancelled-arcs',
  'app:cancelled-review': '#bs-cancelled-review',
  'app:check': '#bs-check',
  'app:check-dense': '#bs-check-dense',
  'app:check-filled': '#bs-check-filled',
  'app:check-round': '#bs-check-round',
  'app:check-round-thin': '#bs-check-round-thin',
  'app:check-thin': '#bs-check-thin',
  'app:close': '#bs-close',
  'app:close-circle': '#bs-close-circle',
  'app:close-fat': '#bs-close-fat',
  'app:complete-arcs': '#bs-complete-arcs',
  'app:copy': '#bs-copy',
  'app:dashboard': '#bs-dashboard',
  'app:date': '#bs-date',
  'app:date-picker': '#bs-date-picker',
  'app:delayed': '#bs-delayed',
  'app:delayed-arcs': '#bs-delayed-arcs',
  'app:delete': '#bs-delete',
  'app:dialog-back': '#bs-dialog-back',
  'app:dialog-close': '#bs-dialog-close',
  'app:discount': '#bs-discount',
  'app:discover': '#bs-discover',
  'app:done': '#bs-done',
  'app:dots-filled': '#bs-dots-filled',
  'app:double-arrow': '#bs-double-arrow',
  'app:download': '#bs-download',
  'app:download-solid': '#bs-download-solid',
  'app:due-arcs': '#bs-due-arcs',
  'app:ebook': '#bs-ebook',
  'app:ebook-alt': '#bs-ebook-alt',
  'app:ellipse': '#bs-ellipse',
  'app:ellipse-horizontal': '#bs-ellipse-horizontal',
  'app:email': '#bs-email',
  'app:email-alt': '#bs-email-alt',
  'app:epub-preview': '#bs-epub-preview',
  'app:equalizer': '#bs-equalizer',
  'app:error': '#bs-error',
  'app:exclamation': '#bs-exclamation',
  'app:excluded': '#bs-excluded',
  'app:external-review': '#bs-external-review',
  'app:facebook': '#bs-facebook',
  'app:facebook-small': '#bs-facebook-small',
  'app:filter': '#bs-filter',
  'app:flag': '#bs-flag',
  'app:flag-filled': '#bs-flag-filled',
  'app:flag-point': '#bs-flag-point',
  'app:globe': '#bs-globe',
  'app:following': '#bs-following|0 0 30 16', // use pipe separator to provide viewBox, see https://v1.quasar.dev/vue-components/icon#svg-use-way
  'app:following-authors': '#bs-following-authors',
  'app:forward': '#bs-forward',
  'app:glasses': '#bs-glasses',
  'app:goodreads': '#bs-goodreads',
  'app:google-play': '#bs-google-play',
  'app:head-phones': '#bs-head-phones',
  'app:inactive': '#bs-inactive',
  'app:inbox': '#bs-inbox',
  'app:info': '#bs-info',
  'app:instagram': '#bs-instagram',
  'app:itunes': '#bs-itunes',
  'app:jcb': '#bs-jcb',
  'app:kindle': '#bs-kindle',
  'app:kobo': '#bs-kobo',
  'app:lightning': '#bs-lightning',
  'app:lightning-solid': '#bs-lightning-solid',
  'app:link': '#bs-link',
  'app:lock': '#bs-lock',
  'app:logout': '#bs-logout',
  'app:logout-alt': '#bs-logout-alt',
  'app:magnifier': '#bs-magnifier',
  'app:magnifier-dense': '#bs-magnifier-dense',
  'app:maintenance': '#bs-maintenance',
  'app:mastercard': '#bs-mastercard',
  'app:message-filled': '#bs-message-filled',
  'app:messages': '#bs-messages',
  'app:messages-no-unread': '#bs-messages-no-unread',
  'app:minus': '#bs-minus',
  'app:mobile-menu': '#bs-mobile-menu',
  'app:mobile-menu-close': '#bs-mobile-menu-close',
  'app:mobile-next': '#bs-mobile-next',
  'app:new-arc-participant': '#bs-new-arc-participant',
  'app:new-review': '#bs-new-review',
  'app:notifications': '#bs-notifications',
  'app:notifications-no-unread': '#bs-notifications-no-unread',
  'app:offline': '#bs-offline',
  'app:open-mail': '#bs-open-mail',
  'app:open-mail-alt': '#bs-open-mail-alt',
  'app:padlock': '#bs-padlock',
  'app:padlock-circle': '#bs-padlock-circle',
  'app:password-hidden': '#bs-password-hidden',
  'app:password-visible': '#bs-password-visible',
  'app:pen-names': '#bs-pen-names',
  'app:pen-names-alt': '#bs-pen-names-alt',
  'app:pen-names-alt-no-unread': '#bs-pen-names-alt-no-unread',
  'app:pencil': '#bs-pencil',
  'app:pending': '#bs-pending',
  'app:pending-arcs': '#bs-pending-arcs',
  'app:pending-dots': '#bs-pending-dots',
  'app:people': '#bs-people',
  'app:plug-female': '#bs-plug-female',
  'app:plug-male': '#bs-plug-male',
  'app:plus': '#bs-plus',
  'app:plus-rounded': '#bs-plus-rounded',
  'app:publisher-role': '#bs-publisher-role',
  'app:question-circle': '#bs-question-circle',
  'app:reader': '#bs-reader',
  'app:reader-no-unread': '#bs-reader-no-unread',
  'app:reader-role': '#bs-reader-role',
  'app:recycle': '#bs-recycle',
  'app:recycle-vertical': '#bs-recycle-vertical',
  'app:rejected-review': '#bs-rejected-review',
  'app:report-pirate': '#bs-report-pirate',
  'app:reviewer': '#bs-reviewer',
  'app:reviews': '#bs-reviews',
  'app:ribbon': '#bs-ribbon',
  'app:saved-arc-ending-soon': '#bs-saved-arc-ending-soon',
  'app:saved-arc-low-copies': '#bs-saved-arc-low-copies',
  'app:sent': '#bs-sent',
  'app:settings': '#bs-settings',
  'app:share': '#bs-share',
  'app:sheet': '#bs-sheet',
  'app:smashwords': '#bs-smashwords',
  'app:social-share': '#bs-social-share',
  'app:sort': '#bs-sort',
  'app:star': '#bs-star',
  'app:storygraph': '#bs-storygraph',
  'app:star-empty': '#bs-star-empty',
  'app:star-full': '#bs-star-full',
  'app:star-half': '#bs-star-half',
  'app:star-outline': '#bs-star-outline',
  'app:star-tick': '#bs-star-tick',
  'app:status-cancelled': '#bs-status-cancelled',
  'app:status-complete': '#bs-status-complete',
  'app:status-waiting': '#bs-status-waiting',
  'app:stop': '#bs-stop',
  'app:stop-alt': '#bs-stop-alt',
  'app:stop-thin': '#bs-stop-thin',
  'app:support': '#bs-support',
  'app:tada-l': '#bs-tada-l',
  'app:tada-r': '#bs-tada-r',
  'app:tag-valued-reviewer': '#bs-tag-valued-reviewer',
  'app:tag-top-reviewer': '#bs-tag-top-reviewer',
  'app:team-members': '#bs-team-members',
  'app:teams': '#bs-teams',
  'app:teams-person': '#bs-teams-person',
  'app:tiktok': '#bs-tiktok',
  'app:time-to-publish': '#bs-time-to-publish',
  'app:times-circle': '#bs-times-circle',
  'app:trash': '#bs-trash',
  'app:twitter': '#bs-twitter',
  'app:unread': '#bs-unread',
  'app:upgrade': '#bs-upgrade',
  'app:va-role': '#bs-va-role',
  'app:vertical-dots': '#bs-vertical-dots',
  'app:visa': '#bs-visa',
  'app:visit-link': '#bs-visit-link',
  'app:website': '#bs-website',
  'app:your-teams': '#bs-your-teams',
  'app:x': '#bs-x'
}
